import { useMemo } from 'react';

const useBillingDayOfMonthOptions = (offer, policyType) => {
  return useMemo(() => {
    if (!offer || !offer.options.find((o) => o.type === policyType)) {
      return null;
    }

    const options = [];
    for (let i = 1; i <= 28; i += 1) {
      options.push({ id: i, value: i.toString() });
    }

    return options;
  }, [offer, policyType]);
};

export default useBillingDayOfMonthOptions;
